import { createSafeContext } from '@shared/utils';

interface MenuContextValue {
  setItemNode: (node: HTMLElement | null) => void;
  activeIndex: number | null;
}

export const [MenuProvider, useMenuContext] = createSafeContext<MenuContextValue>('Menu');
